import { type FC } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface CustomCoversFilterProps {
  onCreateCover: () => void;
}

export const CustomCoversFilter: FC<CustomCoversFilterProps> = ({
  onCreateCover,
}) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("platformCustomCovers.filter.title")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={onCreateCover}
        >
          {t("common.actions.add")}
        </Button>
      }
      fields={{
        search: true,
      }}
    />
  );
};
